import { createConsumer } from "@rails/actioncable";

const MessagesChannel = {
  consumer: null,
  subscription: null,
  chatId: null,

  init() {
    const chatIdElement = document.getElementById("messages-chat-id");
    if (!chatIdElement) {
      this.disconnect();
      return;
    }

    const nextChatId = chatIdElement.value;
    if (!nextChatId) {
      this.disconnect();
      return;
    }

    if (this.chatId === nextChatId && this.subscription) {
      return;
    }

    this.disconnect();
    this.chatId = nextChatId;
    this.connect();
  },

  connect() {
    this.consumer ||= createConsumer();
    this.subscribe();
  },

  subscribe() {
    this.subscription = this.consumer.subscriptions.create(
      { channel: "MessagesChannel", chat_id: this.chatId },
      {
        received: (data) => {
          this.handleMessage(data);
        },
      },
    );
  },

  handleMessage(data) {
    if (data.action === "new_entry") {
      this.appendMessage(data);
    }
  },

  appendMessage(data) {
    const thread = document.querySelector(".message-thread");
    if (!thread) return;

    const currentUserId = Number(document.getElementById("current-user-id")?.value);
    if (Number.isInteger(currentUserId) && currentUserId === Number(data.user_id)) {
      return;
    }

    const placeholder = thread.querySelector(".text-muted.padding-20");
    if (placeholder) {
      placeholder.remove();
    }

    const messageHtml = this.buildMessageHtml(data);
    thread.insertAdjacentHTML("beforeend", messageHtml);
    thread.scrollTop = thread.scrollHeight;
  },

  buildMessageHtml(data) {
    const isOwn = data.is_own;
    const bubbleClass = isOwn ? "message-outgoing" : "message-incoming";

    let html = `<div class="message-bubble ${bubbleClass}">`;

    if (!isOwn && data.sender_name) {
      html += `<div class="bubble-sender">${this.escapeHtml(data.sender_name)}</div>`;
    }

    if (data.body) {
      html += `<div class="bubble-content"><p>${this.escapeHtml(data.body).replace(/\n/g, "</p><p>")}</p></div>`;
    }

    if (data.attachments && data.attachments.length > 0) {
      const attachmentsHtml = data.attachments.map((attachment) => {
        if (attachment.is_image) {
          return `<a href="${attachment.url}" target="_blank"><img src="${attachment.url}" alt="${this.escapeHtml(attachment.name)}" class="attachment-image"></a>`;
        }

        return `<a href="${attachment.url}" class="attachment-file" target="_blank"><i class="fa fa-paperclip"></i> ${this.escapeHtml(attachment.name)}</a>`;
      }).join("");

      html += `<div class="bubble-attachments">${attachmentsHtml}</div>`;
    }

    html += `<div class="bubble-timestamp" data-controller="local-date" data-local-date-timestamp-value="${data.created_at}" data-local-date-format-value="datetime"></div>`;
    html += "</div>";

    return html;
  },

  escapeHtml(text) {
    if (!text) return "";
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  },

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  },
};

document.addEventListener("DOMContentLoaded", () => MessagesChannel.init());
window.addEventListener("beforeunload", () => MessagesChannel.disconnect());

export default MessagesChannel;
